import './style.scss';

export function appointment_hero_block() {
  const block = document.querySelector('.appointment_hero_block');
  if (!block) return;
  
}
